import useAnalyticsCalls from '@/hooks/use-analytics';
import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

// This hook enables page view reports to the analytics packages
export default function useAnalyticsPageViews() {
  const analytics = useAnalyticsCalls();
  const location = useLocation();
  const previousPathnameRef = useRef('');

  useEffect(() => {
    // Skip generic page view for quizlet routes — they fire their own specific events
    if (location.pathname.startsWith('/quizlet/')) {
      previousPathnameRef.current = location.pathname;
      return;
    }

    if (!previousPathnameRef.current || previousPathnameRef.current !== location.pathname) {
      // Construct the previous page URL for SPA referrer tracking
      const previousPageUrl = previousPathnameRef.current
        ? `${window.location.origin}${previousPathnameRef.current}`
        : undefined; // On first page load, use document.referrer (external referrer)

      // Extract source from URL parameters for flows that use URL-based source tracking
      // (e.g., risk_assessment, risk_score_reveal)
      const searchParams = new URLSearchParams(location.search);
      const urlSource = searchParams.get('source');

      analytics.callPageView({
        page_name: location.pathname,
        ...(previousPageUrl && { referrer: previousPageUrl }),
        ...(urlSource && { source: urlSource }),
      });

      // Update the previous pathname for next navigation
      previousPathnameRef.current = location.pathname;
    }
  }, [location.pathname, location.search, analytics]);
}
